// The three vocabularies that make up a telemetry tag: who acted, what they
// did, and what they did it to.
//
// Regular (not const) enums so they can be consumed as values across packages.
// Both former copies were `const enum`s, which admin and business-web cannot
// consume: they compile with isolatedModules, which forbids ambient const
// enums. Same reasoning as `MarketPlaceStatus`.
//
// Hoisted from `packages/server/src/domain/enums/AfriexTelemetryTag.ts` and
// `packages/admin/src/types/TelemetryTypes.ts`, which were byte-identical.
//
// The `AfriexTelemetryTag` composite itself is deliberately NOT hoisted: the
// server declares it as a fixed [subject, action, object] tuple and admin as a
// union widened with `| string`, so the two contracts genuinely disagree.
// Resolving that is a decision, not a mechanical move.
export var AfriexTelemetrySubject;
(function (AfriexTelemetrySubject) {
    AfriexTelemetrySubject["User"] = "USER";
    AfriexTelemetrySubject["Admin"] = "ADMIN";
    AfriexTelemetrySubject["System"] = "SYSTEM";
})(AfriexTelemetrySubject || (AfriexTelemetrySubject = {}));
export var AfriexTelemetryAction;
(function (AfriexTelemetryAction) {
    AfriexTelemetryAction["Created"] = "CREATED";
    AfriexTelemetryAction["Updated"] = "UPDATED";
    AfriexTelemetryAction["Deleted"] = "DELETED";
    AfriexTelemetryAction["Credited"] = "CREDITED";
    AfriexTelemetryAction["Debited"] = "DEBITED";
    AfriexTelemetryAction["Blocked"] = "BLOCKED";
    AfriexTelemetryAction["Unblocked"] = "UNBLOCKED";
    AfriexTelemetryAction["LoggedIn"] = "LOGGED_IN";
    AfriexTelemetryAction["LoggedOut"] = "LOGGED_OUT";
    AfriexTelemetryAction["Started"] = "STARTED";
    AfriexTelemetryAction["Completed"] = "COMPLETED";
    AfriexTelemetryAction["Failed"] = "FAILED";
    AfriexTelemetryAction["Referred"] = "REFERRED";
    AfriexTelemetryAction["Verified"] = "VERIFIED";
    AfriexTelemetryAction["Unverified"] = "UNVERIFIED";
    AfriexTelemetryAction["Submitted"] = "SUBMITTED";
    AfriexTelemetryAction["Approved"] = "APPROVED";
    AfriexTelemetryAction["Exported"] = "EXPORTED";
})(AfriexTelemetryAction || (AfriexTelemetryAction = {}));
export var AfriexTelemetryObject;
(function (AfriexTelemetryObject) {
    AfriexTelemetryObject["Account"] = "ACCOUNT";
    AfriexTelemetryObject["Address"] = "ADDRESS";
    AfriexTelemetryObject["Bank"] = "BANK";
    AfriexTelemetryObject["Card"] = "CARD";
    AfriexTelemetryObject["Deposit"] = "DEPOSIT";
    AfriexTelemetryObject["Document"] = "DOCUMENT";
    AfriexTelemetryObject["Email"] = "EMAIL";
    AfriexTelemetryObject["KYC"] = "KYC";
    AfriexTelemetryObject["MobileMoney"] = "MOBILE_MONEY";
    AfriexTelemetryObject["NameResolution"] = "NAME_RESOLUTION";
    AfriexTelemetryObject["OTCDeskCounterparty"] = "OTC_DESK_COUNTERPARTY";
    AfriexTelemetryObject["OTCDeskTrade"] = "OTC_DESK_TRADE";
    AfriexTelemetryObject["OTCVolume"] = "OTC_VOLUME";
    AfriexTelemetryObject["Phone"] = "PHONE";
    AfriexTelemetryObject["Promo"] = "PROMO";
    AfriexTelemetryObject["Rate"] = "RATE";
    AfriexTelemetryObject["Swap"] = "SWAP";
    AfriexTelemetryObject["Transaction"] = "TRANSACTION";
    AfriexTelemetryObject["Transfer"] = "TRANSFER";
    AfriexTelemetryObject["User"] = "USER";
    AfriexTelemetryObject["Wallet"] = "WALLET";
    AfriexTelemetryObject["Withdrawal"] = "WITHDRAWAL";
})(AfriexTelemetryObject || (AfriexTelemetryObject = {}));
//# sourceMappingURL=AfriexTelemetry.js.map